import moment, { type Moment } from 'moment';
import useCalendarContext from '../../CalendarContext';
import { type EventsAndTimeslots } from 'types/Event';
import {isSameDate} from 'utils/calendar';
import useStyles from './DayEvents.styles';
import DayEvent from './DayEvent';

const MAX_EVENTS_TO_DISPLAY = 3;

type ExtraEventsOrTimeslotsProps = {
  total: number;
};

const ExtraEventsOrTimeslots = ({
  total,
}: ExtraEventsOrTimeslotsProps): JSX.Element | null => {
  const classes = useStyles();

  if (total > 0) {
    return (
      <div
        className={classes.extraEventsOrTimeslots}
        data-testid="extra-events-or-timeslots"
      >
        +{total}
      </div>
    );
  }

  return null;
};

type DayEventsPureProps = {
  dayEventsAndTimeslots: EventsAndTimeslots;
};

const DayEventsPure = ({
  dayEventsAndTimeslots,
}: DayEventsPureProps): JSX.Element => {
  const classes = useStyles();
  const eventsOrTimeslotsToDisplay = dayEventsAndTimeslots.slice(
    0,
    MAX_EVENTS_TO_DISPLAY,
  );
  const extraEventsOrTimeslots = dayEventsAndTimeslots.slice(
    MAX_EVENTS_TO_DISPLAY,
    dayEventsAndTimeslots.length,
  );

  return (
    <div className={classes.dayEventsContainer}>
      {eventsOrTimeslotsToDisplay.map((eventOrTimeslot, index) => (
        <DayEvent eventOrTimeslot={eventOrTimeslot} key={index} />
      ))}

      <ExtraEventsOrTimeslots total={extraEventsOrTimeslots.length} />
    </div>
  );
};

type DayEventsProps = {
  date: Moment;
};

const DayEvents = ({ date }: DayEventsProps): JSX.Element => {
  const { currentMonthEventsAndTimeslots } = useCalendarContext();
  
  const dayEventsAndTimeslots = currentMonthEventsAndTimeslots.filter(
    (eventOrTimeslot) =>
      isSameDate(moment(eventOrTimeslot.date), date),
  );

  return <DayEventsPure dayEventsAndTimeslots={dayEventsAndTimeslots} />;
};

export default DayEvents;
